import { Component, EventEmitter, Input, Output } from "@angular/core";
import { OrderListingPaginatedService } from "../../../../core/services/order-listing-paginated.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ProjectInvoiceReportSalesInvoiceList } from "../../../../core/models/orders/getProjectInvoiceReportSalesResponseDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { DialogModule } from "primeng/dialog";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-invoice-pdf-dialogue",
  templateUrl: "./invoice-pdf-dialogue.component.html",
  styleUrls: ["./invoice-pdf-dialogue.component.scss"],
  imports: [DialogModule, CommonModule],
})
export class InvoicePdfDialogueComponent {
  @Input() displayModal!: boolean;
  @Input() invoiceList: ProjectInvoiceReportSalesInvoiceList[] = [];
  @Output() closeDialogEvent = new EventEmitter();

  constructor(
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private _orderListingPaginatedService: OrderListingPaginatedService
  ) {}

  closeModalDialog() {
    this.closeDialogEvent.emit();
  }

  getProjectInvoiceReport(item: ProjectInvoiceReportSalesInvoiceList) {
    this._loaderService.setLoaderState(true);
    this._orderListingPaginatedService
      .getProjectInvoiceReport({
        InvoiceDate: item?.InvoiceDate ?? "",
        ProjectInvoiceId: item?.ProjectInvoiceId,
      })
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data?.reportBase64String) {
            const blob = this.b64toBlob(
              res.data.reportBase64String,
              "application/pdf"
            );
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl);
          } else {
            this._toastr.error(
              "Error",
              res.message || "Failed To Fetch Invoice PDF"
            );
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Failed To Fetch Invoice PDF");
        },
      });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
